module.exports = __webpack_public_path__ + "img/cb.ca892477.png";